import { http } from '@/http/axios.js'
export function getDetailAPI(key) {
  return http({
    url: '/api/company/setting/getSetting',
    method: 'get',
    params: { key }
  })
}
export function settingAPI(data) {
  return http({
    url: '/api/company/setting/setting',
    method: 'post',
    data
  })
}
